import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { startseiteDZTconfig } from "./welcome-configs/startseite-dzt-config";

export const pageConfigStartseite: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.StartSeiteBot),
    welcome: startseiteDZTconfig,
};
